/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NotesIcon from '@material-ui/icons/Notes';
import { useTranslation } from 'react-i18next';
import SummaryCard from 'components/common/SummaryCard/SummaryCard';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function AdditionalNotesCard({ additionalNotesEntries, isSummary, readOnly = false, cardTitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      Icon={NotesIcon}
      cardTitle={cardTitle ?? t('submission.additional.notes')}
      cardsubTitle=""
      entries={additionalNotesEntries}
      sectionName="submission_additionalNotes"
      isSummary={isSummary}
      readOnly={readOnly}
      customClassName="additionalNotes"
      className={classes}
    />
  );
}
